import script from "./BlockProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockProducts.vue?vue&type=script&setup=true&lang=js"

import "./BlockProducts.vue?vue&type=style&index=0&id=3569e070&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3569e070"]])

export default __exports__